import SignUpHome from '../../Auth/SignUp/SignUpHome'
import SignUpPassword from '../../Auth/SignUp/SignUpPassword'
import SignUpVerify from '../../Auth/SignUp/SignUpVerify'
import SignupStore from '../../Auth/stores/SignupStore'
import React, { useCallback, useEffect, useState } from 'react'
import SignUpForm from '../../Auth/SignUp/SignUpForm'
import { SIGN_UP_STEPS } from './types'
import { State } from '../SignIn/types'
import SignInStore from '../../Auth/stores/SignInStore'
import { useNavigation, useRoute } from '@react-navigation/native'

interface SignUpFlowProps {
  initialStep?: SIGN_UP_STEPS
  onLogin: () => void
  onUserExists: (args: State) => void
  onSuccess?: () => void
}

export const SignUpFlow: React.FC<SignUpFlowProps> = ({
  initialStep = SIGN_UP_STEPS.HOME,
  onLogin,
  onSuccess,
  onUserExists,
}) => {
  const navigation = useNavigation() as any
  const route = useRoute()
  const { setValue, setLogin, type } = SignupStore
  const { setCodeVerifier } = SignInStore

  const [step, setStep] = useState(initialStep)

  useEffect(() => {
    const signUpType = type || 'password'
    setValue('type', signUpType)
    setLogin(signUpType === 'password' ? SignupStore.email : SignupStore.phone)
  }, [type, setLogin, setValue])

  const handleNext = useCallback(async () => {
    if (step === SIGN_UP_STEPS.HOME && type === 'password') {
      setStep(SIGN_UP_STEPS.PASSWORD)
    }
    if (step === SIGN_UP_STEPS.HOME && type === 'code') {
      setStep(SIGN_UP_STEPS.PHONE_VERIFY)
    }
    if ([SIGN_UP_STEPS.PASSWORD, SIGN_UP_STEPS.PHONE_VERIFY].includes(step)) {
      setStep(SIGN_UP_STEPS.USER_INFO_FORM)
    }
  }, [step, type])

  const handleBack = useCallback(async () => {
    if ([SIGN_UP_STEPS.PHONE_VERIFY, SIGN_UP_STEPS.PASSWORD].includes(step)) {
      setStep(SIGN_UP_STEPS.HOME)
    }
    if (step === SIGN_UP_STEPS.USER_INFO_FORM && type === 'password') {
      setStep(SIGN_UP_STEPS.PASSWORD)
    }

    if (step === SIGN_UP_STEPS.USER_INFO_FORM && type === 'code') {
      setStep(SIGN_UP_STEPS.PHONE_VERIFY)
    }
  }, [step, type])

  const handleDontNavigate = useCallback(
    (value) => {
      setCodeVerifier(false)

      if (value) {
        onLogin()
      }
    },
    [onLogin, setCodeVerifier],
  )

  return (
    <>
      {step === SIGN_UP_STEPS.HOME && (
        <SignUpHome
          onContinue={handleNext}
          navigation={navigation}
          dontNavigate={handleDontNavigate}
          route={route}
          onUserExists={onUserExists}
        />
      )}
      {step === SIGN_UP_STEPS.PHONE_VERIFY && (
        <SignUpVerify
          onContinue={handleNext}
          onBack={handleBack}
          dontNavigate={handleDontNavigate}
          route={route}
          navigation={navigation}
        />
      )}
      {step === SIGN_UP_STEPS.PASSWORD && (
        <SignUpPassword
          onContinue={handleNext}
          onBack={handleBack}
          dontNavigate={handleDontNavigate}
          navigation={navigation}
        />
      )}
      {step === SIGN_UP_STEPS.USER_INFO_FORM && (
        <SignUpForm
          navigation={navigation}
          onBack={handleBack}
          dontNavigate={handleDontNavigate}
          onSuccessSignUp={onSuccess}
        />
      )}
    </>
  )
}
